import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Avatar, Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import students from "../../../../../../assets/icons/students.svg";
import numberOfVideos from "../../../../../../assets/icons/numberOfVideos.svg";
import numberOfHours from "../../../../../../assets/icons/numberOfHours.svg";

interface CourseTeacherPreviewProps {
  courseDetails: {
    avatar: string;
    biography: string;
    competence: string;
    count_courses: number;
    count_hours_lecture: number;
    count_student: number;
    fullname: string;
  };
}

export const CourseTeacherPreview = ({
  courseDetails,
}: CourseTeacherPreviewProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <>
      {courseDetails && (
        <Box>
          <Typography
            sx={{
              fontSize: "34px",
              fontWeight: "bold",
              marginTop: "65px",
              marginBottom: "24px",
            }}>
            Преподаватель
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "24px",
            }}>
            <Avatar
              sx={{
                width: "184px",
                height: "184px",
              }}
              alt={courseDetails.fullname || "Преподаватель"}
              src={courseDetails.avatar}
            />

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: "bold",
                }}>
                {courseDetails.fullname}
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "rgba(1, 18, 36, 0.6)",
                  marginBottom: "24px",
                }}>
                {courseDetails.competence || "Компетенции"}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}>
                <Box sx={{ display: "flex", gap: "9px" }}>
                  <img width={24} src={students} alt="students" />
                  <Typography>
                    {courseDetails.count_student || "Кол-во студентов"}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: "9px" }}>
                  <img width={24} src={numberOfVideos} alt="numberOfVideos" />
                  <Typography>
                    {courseDetails.count_courses || "Кол-во видео"}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: "9px" }}>
                  <img width={24} src={numberOfHours} alt="numberOfHours" />
                  <Typography>
                    {courseDetails.count_hours_lecture || "Кол-во часов"}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          <div>
            <Typography
              sx={{
                fontSize: "18px",
                lineHeight: "24px",
                color: "rgba(1, 18, 36, 0.6)",
                marginBottom: "24px",
                marginTop: "24px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: isExpanded ? "block" : "-webkit-box",
                WebkitLineClamp: isExpanded ? "none" : "8",
                WebkitBoxOrient: "vertical",
                maxHeight: isExpanded ? "none" : "200px",
              }}>
              {courseDetails.biography || "Биография"}
            </Typography>
            <Button
              onClick={toggleExpand}
              sx={{
                display: "flex",
                gap: "5px",

                textTransform: "none",
                color: "#0573E4",
              }}>
              {isExpanded ? (
                <>
                  Скрыть <ExpandLessIcon sx={{ mr: 1 }} />
                </>
              ) : (
                <>
                  {" "}
                  Показать всё <ExpandMoreIcon sx={{ mr: 2 }} />
                </>
              )}
            </Button>
          </div>
        </Box>
      )}
    </>
  );
};
